module.exports = __webpack_public_path__ + "img/0x83c442b5dc4ee0ed0e5249352fa7c75f65d6bfd6.fd79aae2.png";